import React from "react";

import Icon from "../Icon";

import {
    evenInstallments,
    formatPercent,
    installmentsPercentSum,
    rebalanceAfter,
} from "./helpers";

export const InstallmentsEditor = ({ installments, change }) => {
    const rows = installments ?? [];
    const difference = Math.round((100 - installmentsPercentSum(rows)) * 100) / 100;

    const changeDays = (index, value) => change(rows.map((row, current) =>
        current === index ? { ...row, days: value === '' ? '' : Math.max(0, parseInt(value, 10) || 0) } : row
    ));

    const changePercent = (index, value) => {
        const updated = rows.map((row, current) =>
            current === index ? { ...row, percent: value === '' ? '' : Number(value) } : row
        );
        change(rebalanceAfter(updated, index));
    };

    const splitEvenly = days => change(evenInstallments(days));
    const currentDays = () => rows.map(row => Number(row.days) || 0);

    const addInstallment = () => {
        const days = currentDays();
        splitEvenly([...days, (days.length ? days[days.length - 1] : -30) + 30]);
    };

    const removeInstallment = index => splitEvenly(currentDays().filter((day, current) => current !== index));

    return (
        <div className="installments-editor">
            <div className="installments-editor-rows">
                {rows.map((row, index) => (
                    <div className="installments-editor-row" key={index}>
                        <span className="installment-number">{index + 1}ª</span>
                        <label className="installment-field">
                            <input
                                type="number"
                                min="0"
                                inputMode="numeric"
                                aria-label={`Dias da ${index + 1}ª parcela`}
                                value={row.days}
                                onChange={event => changeDays(index, event.target.value)}
                            />
                            <span>dias</span>
                        </label>
                        <label className="installment-field">
                            <input
                                type="number"
                                min="0"
                                max="100"
                                step="0.01"
                                inputMode="decimal"
                                aria-label={`Percentual da ${index + 1}ª parcela`}
                                value={row.percent}
                                onChange={event => changePercent(index, event.target.value)}
                            />
                            <span>%</span>
                        </label>
                        <button
                            type="button"
                            className="installment-remove"
                            aria-label={`Remover a ${index + 1}ª parcela`}
                            onClick={() => removeInstallment(index)}
                            disabled={rows.length === 1}
                        >
                            <Icon name={`delete-small`} size={16} />
                        </button>
                    </div>
                ))}
            </div>

            <div className="installments-editor-foot">
                <button type="button" className="installments-editor-link" onClick={addInstallment}>
                    + Adicionar parcela
                </button>
                {Math.abs(difference) > 0.01 &&
                    <span className="installments-editor-sum">
                        {difference > 0 ? `Faltam ${formatPercent(difference)}%` : `Passou ${formatPercent(-difference)}%`}
                        {' · '}
                        <button type="button" className="installments-editor-link" onClick={() => splitEvenly(currentDays())}>
                            Dividir igualmente
                        </button>
                    </span>
                }
            </div>
        </div>
    );
};

export default InstallmentsEditor;
